import script from "./HeroMain.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroMain.vue?vue&type=script&setup=true&lang=js"

import "./HeroMain.vue?vue&type=style&index=0&id=754a7486&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\chervinskii_mk\\Documents\\ORIS\\Repositories\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-754a7486"]])

export default __exports__